// extracted by mini-css-extract-plugin
export default {"button":"M5ZV5i","wrapper":"NmsGuT","label":"NKg9Mr"};